"use client";

// 👉 Import the necessary Clerk hooks
import { c as _c } from "react/compiler-runtime";
import { useAuth, useUser } from "@clerk/nextjs";
import { usePostHog } from "posthog-js/react";
import { useEffect } from "react";
export default function PostHogAuth() {
  const $ = _c(6);
  const posthog = usePostHog();
  const {
    isSignedIn,
    userId
  } = useAuth();
  const {
    user
  } = useUser();
  let t0;
  let t1;
  if ($[0] !== isSignedIn || $[1] !== posthog || $[2] !== user || $[3] !== userId) {
    t0 = () => {
      if (isSignedIn && userId && user && !posthog._isIdentified()) {
        posthog.identify(userId, {
          email: user.primaryEmailAddress?.emailAddress,
          username: user.username
        });
      }
      if (!isSignedIn && posthog._isIdentified()) {
        posthog.reset();
      }
    };
    t1 = [posthog, user, isSignedIn, userId];
    $[0] = isSignedIn;
    $[1] = posthog;
    $[2] = user;
    $[3] = userId;
    $[4] = t0;
    $[5] = t1;
  } else {
    t0 = $[4];
    t1 = $[5];
  }
  useEffect(t0, t1);
  return null;
}